import React from 'react';
import ScrollReveal from './ScrollReveal';
import '../styles/PromoBanner.css';

function PromoBanner() {
  return (
    <section className="promo-banner">
      <div className="promo-banner-container">
        <ScrollReveal className="promo-banner-left" variant="slide-left" duration={1100}>
          <div className="promo-badge">Naya Villa</div>
          <h2 className="promo-title">
            We give<br />
            the best<br />
            Apartments
          </h2>

          <p className="promo-description">
            Discover thoughtfully designed apartments in the heart of Dar es Salaam, with flexible monthly stays,
            hotel-level comfort, and a dedicated team to take care of every detail of your visit.
          </p>
        </ScrollReveal>

        <ScrollReveal className="promo-banner-right" variant="slide-right" delay={150} duration={1100}>
          <div className="promo-image-card">
            <ScrollReveal
              as="div"
              className="promo-main-photo"
              variant="zoom"
              delay={250}
              duration={1200}
              style={{ backgroundImage: `url('/assest/images/promo-1.jpeg')` }}
            />
            <ScrollReveal
              as="div"
              className="promo-tertiary-photo"
              variant="scale-in"
              delay={400}
              duration={1000}
              style={{ backgroundImage: `url('/assest/images/promo-2.jpeg')` }}
            />
            <ScrollReveal
              as="div"
              className="promo-secondary-photo"
              variant="scale-in"
              delay={520}
              duration={1000}
              style={{ backgroundImage: `url('/assest/images/promo-3.jpeg')` }}
            />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default PromoBanner;
